module.exports = __webpack_public_path__ + "dc0b29d24c5c0f416b9d5d8204e6122a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/5.jpg
// module id = 331
// module chunks = 0